// @flow
import React from "react";
import moment from "moment";
import I18n from "../../../i18n/I18n";
import CONFIG from "../../../config/";
import Helper from "../../../helper/Helper";
import styles from "./DetailHeader.scss";
import { Icon } from "../../common";

const DetailHeader = (props: Object) => {
    const {
        statementNr,
        paidAt,
        paymentRef,
        total,
        currencyCode,
        onBack,
        lang
    } = props;
    return (
        <div className={styles.header}>
            <div className={styles.transactionWrapper}>
                <button onClick={() => onBack()}>
                    <Icon
                        name={lang === "ar" ? "fwd-arrow" : "back-arrow"}
                        className={styles.backArrow}
                    />
                </button>
                <div className={styles.orderNr}>
                    <h6 className={styles.small}>
                        {I18n.getText(
                            "statement-details.transaction",
                            {},
                            "Transaction"
                        )}
                    </h6>
                    <h6 className={styles.title}>{statementNr || ""}</h6>
                </div>
            </div>
            <div className={styles.rightWrapper}>
                <div className={styles.dateWrapper}>
                    <span className={styles.small}>
                        {I18n.getText(
                            "statement-details.date",
                            {},
                            "Date & Time"
                        )}
                    </span>
                    <span className={styles.title}>
                        {moment(paidAt).format("YYYY-MM-DD")}
                    </span>
                </div>
                {paymentRef ? (
                    <div className={styles.dateWrapper}>
                        <span className={styles.small}>
                            {I18n.getText("statement.payment-ref-no", {})}
                        </span>
                        <span className={styles.title}>{paymentRef}</span>
                    </div>
                ) : (
                    ""
                )}
                <div className={styles.amountWrapper}>
                    <span className={styles.small}>
                        {I18n.getText("statement-details.amount", {}, "Amount")}
                    </span>
                    <span className={styles.title}>
                        {I18n.formatCurrency(
                            Helper.formatPrice(total, currencyCode)
                        )}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default DetailHeader;



// WEBPACK FOOTER //
// ./src/components/statement/detailHeader/DetailHeader.js